/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnvironmentToxinsUpsertRequestDto
 */
export interface EnvironmentToxinsUpsertRequestDto {
    /**
     * Unique identifier for the patient's environment toxins record.
     * @type {string}
     * @memberof EnvironmentToxinsUpsertRequestDto
     */
    id: string;
    /**
     * Type of home environment.
     * @type {string}
     * @memberof EnvironmentToxinsUpsertRequestDto
     */
    home: EnvironmentToxinsUpsertRequestDtoHomeEnum;
    /**
     * Details about other home type (required if home is 'Other').
     * @type {string}
     * @memberof EnvironmentToxinsUpsertRequestDto
     */
    homeOther?: string;
    /**
     * Indicates if the patient has air/water filters in their home.
     * @type {boolean}
     * @memberof EnvironmentToxinsUpsertRequestDto
     */
    airWaterFilters: boolean;
    /**
     * Indicates if the patient has chemical exposure.
     * @type {Array<string>}
     * @memberof EnvironmentToxinsUpsertRequestDto
     */
    chemicalExposure?: Array<string>;
    /**
     * Other chemical exposure information.
     * @type {string}
     * @memberof EnvironmentToxinsUpsertRequestDto
     */
    chemicalOther?: string;
    /**
     * Additional information about environmental toxins exposure.
     * @type {string}
     * @memberof EnvironmentToxinsUpsertRequestDto
     */
    additionalInformation?: string;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof EnvironmentToxinsUpsertRequestDto
     */
    isOnboarding?: boolean;
}


/**
 * @export
 */
export const EnvironmentToxinsUpsertRequestDtoHomeEnum = {
    House: 'House',
    Townhouse: 'Townhouse',
    Apartment: 'Apartment',
    Other: 'Other'
} as const;
export type EnvironmentToxinsUpsertRequestDtoHomeEnum = typeof EnvironmentToxinsUpsertRequestDtoHomeEnum[keyof typeof EnvironmentToxinsUpsertRequestDtoHomeEnum];


/**
 * Check if a given object implements the EnvironmentToxinsUpsertRequestDto interface.
 */
export function instanceOfEnvironmentToxinsUpsertRequestDto(value: object): value is EnvironmentToxinsUpsertRequestDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('home' in value) || value['home'] === undefined) return false;
    if (!('airWaterFilters' in value) || value['airWaterFilters'] === undefined) return false;
    return true;
}

export function EnvironmentToxinsUpsertRequestDtoFromJSON(json: any): EnvironmentToxinsUpsertRequestDto {
    return EnvironmentToxinsUpsertRequestDtoFromJSONTyped(json, false);
}

export function EnvironmentToxinsUpsertRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnvironmentToxinsUpsertRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'home': json['home'],
        'homeOther': json['homeOther'] == null ? undefined : json['homeOther'],
        'airWaterFilters': json['airWaterFilters'],
        'chemicalExposure': json['chemicalExposure'] == null ? undefined : json['chemicalExposure'],
        'chemicalOther': json['chemicalOther'] == null ? undefined : json['chemicalOther'],
        'additionalInformation': json['additionalInformation'] == null ? undefined : json['additionalInformation'],
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
    };
}

export function EnvironmentToxinsUpsertRequestDtoToJSON(json: any): EnvironmentToxinsUpsertRequestDto {
    return EnvironmentToxinsUpsertRequestDtoToJSONTyped(json, false);
}

export function EnvironmentToxinsUpsertRequestDtoToJSONTyped(value?: EnvironmentToxinsUpsertRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'home': value['home'],
        'homeOther': value['homeOther'],
        'airWaterFilters': value['airWaterFilters'],
        'chemicalExposure': value['chemicalExposure'],
        'chemicalOther': value['chemicalOther'],
        'additionalInformation': value['additionalInformation'],
        'isOnboarding': value['isOnboarding'],
    };
}

